module.exports = __webpack_public_path__ + "img/red-location.e053e709.svg";